module.exports = __webpack_public_path__ + "img/electric_pending_zone_selected.3a27ffc1.svg";